import { useAsyncRetry } from 'react-use';
import { useApi } from '@backstage/core-plugin-api';
import { awsCodePipelineApiRef } from '../api/AwsCodePipelineApi.esm.js';
import '@aws/aws-core-plugin-for-backstage-react';
import { getCompoundEntityRef } from '@backstage/catalog-model';

function usePipelineExecutions({ entity }) {
  const awsCodePipelineApi = useApi(awsCodePipelineApiRef);
  const {
    loading,
    value: response,
    error,
    retry
  } = useAsyncRetry(async () => {
    return await awsCodePipelineApi.getPipelineExecutionsByEntity({
      entity: getCompoundEntityRef(entity)
    });
  }, []);
  return { loading, response, error, retry };
}

export { usePipelineExecutions };
//# sourceMappingURL=usePipelineExecutions.esm.js.map
